import styled from "styled-components";
import { Form } from "formik";
import { Modal } from "react-bootstrap";

export const Wrapper = styled.div`
  background-color: #060fff;
  width: 100%;
`;

export const Container = styled.section`
  background-color: rgb(255, 255, 255);
  border-radius: 21px;
  z-index: 10;
  padding: 24px;

  @media (max-height: 762px) {
    padding: 18px 25px;
  }
`;

export const ContainerButtons = styled.div`
  max-width: 370px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 30px;
  display: grid;
  row-gap: 10px;
  a {
    text-decoration: none;
    width: 100%;
  }

  @media (max-height: 762px) {
    margin-top: 16px;
    font-size: 14px;
    button {
      height: 32px;

      span {
        font-size: 14px !important;
      }
    }
  }
`;

export const FormContainer = styled(Form)`
  margin-top: 16px;
  width: 100%;

  @media (max-width: 768px) {
    margin-top: 16px;
  }

  @media (max-height: 762px) {
    margin-top: 8px;
  }
`;

export const ModalContainer = styled.div`
  padding: 28px 28px 39px 28px;
  max-width: 620px;
  width: 620px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const ModalHeader = styled.header`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  span {
    color: ${({ theme }) => theme.colors.darkBlue};
    font-size: 20px;
  }

  svg {
    color: ${({ theme }) => theme.colors.darkBlue};
  }

  margin-bottom: 36px;
`;

export const ModalBody = styled.div`
  color: ${({ theme }) => theme.colors.black};
  font-size: 1.125rem;
  max-width: 536px;
  margin-bottom: 36px;
`;

export const ModalFooter = styled.div`
  display: flex;
  flex-direction: column;

  font-size: 1rem;
  span {
    font-weight: bold;
    color: ${({ theme }) => theme.colors.black};
    margin-bottom: 21px;
  }

  a {
    color: ${({ theme }) => theme.colors.darkBlue};
    text-decoration: none;
    cursor: pointer;
  }
  a:first-child {
    margin-bottom: 12px;
  }
`;

export const ModalStyle = styled(Modal)`
  .modal-content {
    max-width: 620px;
    width: auto;
  }
`;

export const Subtitle = styled.span`
  text-align: center;
  font-size: 16px;
  font-family: "Mangueira Medium";
  display: inline-block;

  @media (max-width: 768px) {
    font-size: 12px;
  }

  @media (max-height: 762px) {
    font-size: 12px;
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Title = styled.h2`
  text-align: center;
  color: #000000;
  font-size: 26px;
  font-family: "Mangueira Medium";

  @media (max-width: 768px) {
    font-size: 20px;
  }

  @media (max-height: 762px) {
    font-size: 18px;
  }
`;
